import { StyleRecord, StyleFormData } from '../types';
import { FORM_DEFAULT_VALUES } from '../constants';

/**
 * 将 API 记录转换为表单数据
 */
export const recordToFormData = (record: StyleRecord): Partial<StyleFormData> => {
  return {
    styleName: record.styleName || '',
    styleNameJa: record.styleNameJa || '',
    styleOrder: record.styleOrder !== undefined && record.styleOrder !== null ? record.styleOrder : undefined,
    styleImage: record.styleImage || '',
    status: record.status,
    description: record.description || '',
    descriptionJa: record.descriptionJa || '',
    limitTime: record.limitTime ?? 0,
    model: record.model === undefined || record.model === null ? undefined : String(record.model),
    isSelfStyle: record.isSelfStyle ?? 0,
    styleTypeId: record.styleTypeId,
    defaultSelected: record.defaultSelected ?? 0,
    modelNameSuffix: record.modelNameSuffix,
    modelType: record.modelType,
    isRecommend: record.isRecommend ?? 0,
    recommendSort: record.recommendSort !== undefined && record.recommendSort !== null ? record.recommendSort : undefined,
    workFlowJson: record.workFlowJson,
    pixel: record.pixel,
    gcoins: record.gcoins !== undefined && record.gcoins !== null ? record.gcoins : undefined,
    pcoins: record.pcoins !== undefined && record.pcoins !== null ? record.pcoins : undefined,
    isVipStyle: record.isVipStyle ?? 0,
    minTierLevel: record.minTierLevel,
    // freeUse: record.freeUse ?? 0,
    supportStep: record.supportStep ?? 0,
    stepMin: record.stepMin,
    stepMax: record.stepMax,
    stepDefault: record.stepDefault,
    support4k: record.support4k ?? 0,
    supportLora: record.supportLora ?? 0,
    supportInpaint: record.supportInpaint ?? 0,
    inpaintWorkflowId: record.inpaintWorkflowId,
  };
};

/**
 * 获取表单初始值
 */
export const getFormInitialValues = (record?: StyleRecord | null): Partial<StyleFormData> => {
  if (record) {
    return recordToFormData(record);
  }
  return FORM_DEFAULT_VALUES;
};

